import styled from 'styled-components'
import GridUnit from 'styled-components-grid/dist/cjs/components/GridUnit'

const Cell = styled(GridUnit)`
  padding: 3px 5px;
  box-sizing: border-box;
`

export default Cell
